import { Reducer } from "react";

import { AxiosError, AxiosResponse } from "axios";

import Endpoint from "../../services/api/endpoint";
import { initialSettingState, ISetting, ISettingState } from "../../utils/types/models";
import { IAction, IDictionary } from "../../utils/types/types";

const settingReducer: Reducer<ISettingState, IAction> = (state: ISettingState = initialSettingState, action: IAction): ISettingState => {
	switch (action.type) {
		case "REQUEST_GET_" + Endpoint.Settings:
			state = {
				...state,
				settingsLoading: true,
				settings: null
			};
			break;
		case "REQUEST_GET_" + Endpoint.SettingsByKey:
			state = {
				...state,
				settingsLoading: true,
				setting: null
			};
			break;
		case "REQUEST_FAILURE_GET_" + Endpoint.Settings: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				settingsLoadError: payload.error
			};
			break;
		}
		case "REQUEST_FAILURE_GET_" + Endpoint.SettingsByKey: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				settingsLoadError: payload.error
			};
			break;
		}
		case "REQUEST_SUCCESS_GET_" + Endpoint.Settings: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };
			if (action.payload && payload.response && payload.response.data) {
				state = {
					...state,
					settings: payload.response.data
				};
			}
			break;
		}
		case "REQUEST_SUCCESS_GET_" + Endpoint.SettingsByKey: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };
			if (action.payload && payload.response && payload.response.data) {
				state = {
					...state,
					setting: payload.response.data
				};
			}
			break;
		}
		case "REQUEST_END_GET_" + Endpoint.Settings:
			state = {
				...state,
				settingsLoading: false
			};
			break;
		case "REQUEST_END_GET_" + Endpoint.SettingsByKey:
			state = {
				...state,
				settingsLoading: false
			};
			break;
		case "CLEAR_GET_" + Endpoint.Settings:
			state = {
				...state,
				settings: {},
				settingsLoadError: null
			};
			break;
		case "CLEAR_GET_" + Endpoint.SettingsByKey:
			state = {
				...state,
				setting: null,
				settingsLoadError: null
			};
			break;
		case "REQUEST_PUT_" + Endpoint.Settings:
			state = {
				...state,
				isUpdating: true,
				updateError: null
			};
			break;
		case "REQUEST_FAILURE_PUT_" + Endpoint.Settings: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				updateError: payload.error
			};
			break;
		}
		case "REQUEST_END_PUT_" + Endpoint.Settings:
			state = {
				...state,
				isUpdating: false
			};
			break;
		case "CLEAR_PUT_" + Endpoint.Settings:
			state = {
				...state,
				updateError: null
			};
			break;
		case "UPDATE_SETTING": {
			const settings: IDictionary<ISetting> = { ...state.settings };
			settings[action.settingKey as string] = action.setting as ISetting;
			state = {
				...state,
				settings
			};
		}
	}
	return state;
};

export default settingReducer;
